module.exports = __webpack_public_path__ + "img/album09_02.adefdef6.jpg";